import { Divider, Flex, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { OptionsSelector } from './components/OptionsSelector'
import { Chip } from '@ubirider/pick-component-library'
import { VehicleCategoryLabels } from '../../../../consts/vehicles'

export const Vehicle = ({ licensePlate, info }) => {
  const { t } = useTranslation()

  return (
    <Flex
      bg='neutral.25'
      rounded='8px'
      css={'box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1)'}
      border='1px'
      borderColor='neutral.300'
      paddingInline='16px'
      paddingBlock='16px'
      direction='column'
      minHeight='160px'
      gap='8px'
    >
      <Flex justify='space-between' align='center'>
        <Text fontWeight='bold'>{info.model}</Text>
        <OptionsSelector licensePlate={licensePlate} info={info} />
      </Flex>
      <Divider />
      <Text>{VehicleCategoryLabels[info.category]}</Text>
      <Chip label={licensePlate} />
    </Flex>
  )
}
